export default {"src":"/_next/static/media/compare-icon.a8a7776f.svg","height":170,"width":178,"blurWidth":0,"blurHeight":0};